function isEnvironment(environment: string) {
  return environment === process.env.NODE_ENV;
}

export default isEnvironment;
